import React from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { LabelingContainer } from '~/components/elements/LabelingContainer'
import {
  StyledTextArea,
  type StyledTextAreaProps,
} from '~/components/elements/StyledTextArea'
import { useFormField } from '~/hooks/useFormField'
import { useLogEvent } from '~/hooks/useLogEvent'

import { type InputValues } from '../utils'

export const GoalInput = () => {
  const { t } = useTranslation()
  const { control } = useFormContext<InputValues>()
  const goalField = useFormField(control, 'goal')

  const logEvent = useLogEvent()
  const handleBlur = React.useCallback<
    EH<StyledTextAreaProps, 'onBlur'>
  >(() => {
    goalField.onBlur()
    logEvent('Edit objective', { withSuffix: true })
  }, [goalField, logEvent])

  return (
    <LabelingContainer label={t('objective_kpi')}>
      <StyledTextArea
        autoSize={true}
        rows={1}
        width="100%"
        {...goalField}
        onBlur={handleBlur}
      />
    </LabelingContainer>
  )
}
